{
  "en": {
    "window": {
      "app": "App",
      "customersDashboard": "Dashboard",
      "customersDecisionDocuments": "Decision",
      "customersDecisionProposals": "Decision Proposals",
      "customersDecisionTickets": "Decision",
      "customersDecisionTicketsShow": "Decision",
      "customersDecisions": "Decisions",
      "customersDocuments": "Documents",
      "customersDocumentsAll": "Document overview",
      "customersDocumentsFolder": "Document category",
      "customersDocumentsFolders": "Document categories",
      "customersInspirationLists": "Inspirations",
      "customersInspirationListsShow": "Inspirations",
      "customersInstallmentTerms": "Installments",
      "customersIssues": "Aftercare",
      "customersIssuesList": "Aftercare",
      "customersProjectInformation": "Project Information",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Dashboard",
      "customersRootSettingsProfile": "Settings",
      "customersSettingsProfile": "Settings",
      "customersTickets": "Conversations",
      "customersTicketsNew": "New Conversation",
      "customersTicketsShow": "Conversation",
      "employeesClientContacts": "Contacts",
      "employeesClientContactsNew": "New Contact",
      "employeesClientContactsNewCustomer": "New Customer",
      "employeesClientContactsNewEmployee": "New Team Member",
      "employeesClientContactsNewPartner": "New partner",
      "employeesClientContactsType": "Contacts",
      "employeesClientDashboard": "Dashboard",
      "employeesClientProjects": "Projects",
      "employeesClientProjectsNew": "New Project",
      "employeesClientTickets": "Conversations",
      "employeesClientTicketsNew": "New Conversation",
      "employeesClientTicketsShow": "Conversation",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Activity",
      "employeesProjectAnnouncements": "News Feed",
      "employeesProjectDecisionActivity": "Activity",
      "employeesProjectDecisionDocuments": "Decision",
      "employeesProjectDecisionProposalTemplate": "Proposal Templates",
      "employeesProjectDecisionProposals": "Proposals",
      "employeesProjectDecisionReminders": "Reminders",
      "employeesProjectDecisionTickets": "Conversations",
      "employeesProjectDecisionTicketsShow": "Conversation",
      "employeesProjectDecisionTypeNew": "New Decision",
      "employeesProjectDecisionTypes": "Decisions",
      "employeesProjectDecisions": "Decisions",
      "employeesProjectDecisionsEdit": "Decisions",
      "employeesProjectDecisionsNew": "New Decision",
      "employeesProjectDocuments": "Documents",
      "employeesProjectInformationPageActivity": "Activity",
      "employeesProjectInformationPageAftercare": "Aftercare",
      "employeesProjectInformationPageDecisions": "Decisions",
      "employeesProjectInformationPageDocuments": "Documents",
      "employeesProjectInformationPageInformation": "Information",
      "employeesProjectInformationPageInstallments": "Installments",
      "employeesProjectInformationPageLevels": "Levels",
      "employeesProjectInformationPageMilestones": "Milestones",
      "employeesProjectInformationPageSpaces": "Spaces",
      "employeesProjectInformationPageSurveys": "Surveys",
      "employeesProjectInformationPageTasks": "Tasks",
      "employeesProjectInformationPageTickets": "Conversations",
      "employeesProjectInstallmentGroup": "Financials",
      "employeesProjectInstallmentGroupNew": "New Installment Term",
      "employeesProjectInstallmentGroups": "Financials",
      "employeesProjectInstallmentGroupsList": "Financials",
      "employeesProjectInstallmentGroupsMatrix": "Installments",
      "employeesProjectInstallmentNew": "New Installments",
      "employeesProjectIssueListTypeIssues": "Snagging List - All snags",
      "employeesProjectIssueListTypeNew": "New Snagging List",
      "employeesProjectIssueListTypeUnits": "Snagging List - Unit Overview",
      "employeesProjectIssueListTypes": "Snagging Lists",
      "employeesProjectIssueListUnitDocuments": "Unit snags - Documents",
      "employeesProjectIssueListUnitIssues": "Unit snags",
      "employeesProjectIssueListUnitTickets": "Unit Snags - Tickets",
      "employeesProjectIssueListUnitTicketsShow": "Conversations",
      "employeesProjectIssueListsNew": "New Snags",
      "employeesProjectMilestones": "Milestones",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Sales",
      "employeesProjectSurveySummary": "Survey",
      "employeesProjectSurveyTypes": "Surveys",
      "employeesProjectSurveys": "Survey",
      "employeesProjectTickets": "Conversations",
      "employeesProjectTicketsEmailConversations": "Emails",
      "employeesProjectTicketsEmailConversationsShow": "Email",
      "employeesProjectTicketsNew": "New Conversation",
      "employeesProjectTicketsShow": "Conversations",
      "employeesProjectTodoLists": "Tasks",
      "employeesSettingsClientAftercare": "Aftercare",
      "employeesSettingsClientInformation": "Admin",
      "employeesSettingsClientIntegrations": "Integrations",
      "employeesSettingsProfile": "Profile",
      "level": "Level",
      "mployeesProjectInstallmentGroups": "Financials",
      "partnersClientProjects": "Projects",
      "partnersProjectDecisionDocuments": "Documents",
      "partnersProjectDecisionProposals": "Proposals",
      "partnersProjectDecisionTickets": "Conversations",
      "partnersProjectDecisionTicketsShow": "Conversation",
      "partnersProjectDecisionTypesItems": "Decisions",
      "partnersProjectDecisions": "Decisions",
      "partnersProjectDocuments": "Documents",
      "partnersProjectDocumentsUnit": "Documents",
      "partnersProjectIssueListTypeIssues": "Snagging List - All snags",
      "partnersProjectIssueListTypeUnits": "Snagging List - Unit Overview",
      "partnersProjectIssueListTypes": "Aftercare",
      "partnersProjectIssueListUnitDocuments": "Unit Snags - Documents",
      "partnersProjectIssueListUnitIssues": "Unit snags",
      "partnersProjectIssueListUnitTickets": "Unit Snags - Tickets",
      "partnersSettingsProfile": "Profile",
      "root": "App"
    }
  }
}
